<template lang="pug">
b-modal#editMissionOperatorModal(
  ref="editMissionOperator"
  :title="modalTitle"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
  @hidden="onModalHidden"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$t('ui.title')").mb-2(v-if="missionTitle")
      .mission-edit-chip.w-100
        input.mission-edit-chip-input.form-control.form-control-sm(
          type="text"
          :value="missionTitle"
          disabled
          readonly
          tabindex="-1"
        )
    //- b-form-group(:label="$t('ui.id')").mb-2
    //-   span.font-weight-bold {{ mission_id }}
    b-form-group(:label="$t('ui.point')").mb-2
      DebounceInput(
        ref="badgeInput"
        size="sm"
        type="text"
        :dirty="$v.badge.$dirty"
        :error="$v.badge.$error"
        v-model.trim.lazy="$v.badge.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.badge" :name="$t('ui.point')")
    //- b-form-group(:label="$t('ui.credit')").mb-2
    //-   DebounceInput(
    //-     size="sm"
    //-     type="text"
    //-     v-model.trim="credit"
    //-     :disabled="loading"
    //-   )
    //- b-form-group(:label="$t('ui.inbox')").mb-2
    //-   DebounceInput(
    //-     size="sm"
    //-     type="text"
    //-     v-model.trim="inbox"
    //-     :disabled="loading"
    //-   )
    //- b-form-group(:label="$t('ui.campaign_id')").mb-2
    //-   CampaignLookup(
    //-     :key="'mission-campaign-' + String(operatorID || '')"
    //-     :operatorID="operatorID"
    //-     v-model="campaign"
    //-     size="sm"
    //-     :disabled="loading || !inboxHasValue"
    //-   )
    div.row
      div.col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import DebounceInput from "@/library/DebounceInput";
import CampaignLookup from "@/library/CampaignLookup";
import { integer, requiredIf, minValue } from "vuelidate/lib/validators";
import ValidateResult from "@/library/ValidateResult";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    CampaignLookup,
    ValidateResult
  },
  props: {
    item: {
      type: Object,
      default: null
    },
    submitAsStatusEnable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      mission_id: null,
      missionTitle: "",
      badge: "",
      credit: "",
      inbox: "",
      campaign: "",
      didSubmitSuccess: false,
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    inboxHasValue() {
      return String(this.inbox || "").trim() !== "";
    },
    modalTitle() {
      return this.submitAsStatusEnable
        ? this.$t("ui.combine.enable_mission_reward")
        : this.$t("ui.combine.edit_mission_reward");
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
  },
  validations: {
    badge: {
      required : requiredIf(function () {
        return !this.isOperator;
      }),
      integer,
      minValue: minValue(1)
    }
  },
  watch: {
    inbox() {
      if (!this.inboxHasValue) {
        this.campaign = "";
      }
    }
  },
  methods: {
    done(evt) {
      evt.preventDefault();
      if (this.$v.$invalid) return;

      this.submit();
    },
    parseRewardPayload() {
      const raw = this.item && this.item.reward_payload;
      if (raw == null || raw === "") {
        return {};
      }
      if (typeof raw === "object" && !Array.isArray(raw)) {
        return raw;
      }
      if (typeof raw === "string") {
        try {
          return JSON.parse(raw);
        } catch (e) {
          return {};
        }
      }
      return {};
    },
    optionalInt(str) {
      if (str === "" || str == null || String(str).trim() === "") {
        return null;
      }
      const n = parseInt(String(str).trim(), 10);
      return Number.isFinite(n) ? n : NaN;
    },
    optionalDecimal(str) {
      if (str === "" || str == null || String(str).trim() === "") {
        return null;
      }
      const n = Number(String(str).trim());
      return Number.isFinite(n) ? n : NaN;
    },
    rewardProvided(badgeVal, creditVal, inboxVal, campaignStr) {
      const camp = campaignStr != null && String(campaignStr).trim() !== "";
      return (
        badgeVal != null ||
        creditVal != null ||
        inboxVal != null ||
        camp
      );
    },
    submit() {
      const badgeVal = this.optionalInt(this.badge);
      const creditVal = this.optionalDecimal(this.credit);
      const inboxVal = this.optionalInt(this.inbox);
      const campaignTrim =
        this.campaign != null ? String(this.campaign).trim() : "";

      // if (
      //   Number.isNaN(badgeVal) ||
      //   Number.isNaN(creditVal) ||
      //   Number.isNaN(inboxVal)
      // ) {
      //   this.$helpers.showDialog(
      //     this.$t("ui.alert"),
      //     this.$t("message.mission_invalid_reward_numbers"),
      //     "error"
      //   );
      //   return;
      // }

      // if (!this.rewardProvided(badgeVal, creditVal, inboxVal, campaignTrim)) {
      //   this.$helpers.showDialog(
      //     this.$t("ui.alert"),
      //     this.$t("message.mission_reward_at_least_one"),
      //     "error"
      //   );
      //   return;
      // }

      // if (inboxVal != null && campaignTrim === "") {
      //   this.$helpers.showDialog(
      //     this.$t("ui.alert"),
      //     this.$t("message.mission_campaign_required_when_inbox"),
      //     "error"
      //   );
      //   return;
      // }

      let url = this.submitAsStatusEnable
        ? config.missionStatusUpdateUrl()
        : config.missionOperatorUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        audit_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        mission_id: this.mission_id,
        badge: badgeVal,
        credit: creditVal,
        inbox: inboxVal,
        campaign: campaignTrim === "" ? null : campaignTrim
      };
      if (this.submitAsStatusEnable) {
        json.new_status = true;
      }

      this.feedback.success = true;
      this.loading = true;

      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.didSubmitSuccess = true;
                this.$emit("clicked");
                this.$refs.editMissionOperator.hide();
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
                this.$emit("failed", "edit_mission_reward", this.feedback.status);
                this.$refs.editMissionOperator.hide();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        }.bind(this),
        function() {
          this.loading = false;
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }.bind(this)
      );
    },
    reset() {
      this.feedback.success = true;
      this.feedback.status = "";
      this.didSubmitSuccess = false;
    },
    onModalHidden() {
      if (this.submitAsStatusEnable && !this.didSubmitSuccess && this.item) {
        this.$emit("status-enable-cancelled", this.item);
      }
      this.didSubmitSuccess = false;
    },
    shown() {
      const obj = this.parseRewardPayload();
      this.mission_id = this.item && this.item.mission_id;
      this.missionTitle =
        (this.item && (this.item.title_en || this.item.title_cn)) || "";
      this.badge = obj.badge != null ? String(obj.badge) : "";
      this.credit = obj.credit != null ? String(obj.credit) : "";
      this.inbox = obj.inbox != null ? String(obj.inbox) : "";
      if (!String(this.inbox || "").trim()) {
        this.campaign = "";
      } else {
        this.campaign =
          obj.campaign != null ? String(obj.campaign) : "";
      }
      this.$nextTick(() => {
        if (this.$refs.badgeInput && this.$refs.badgeInput.$el) {
          this.$refs.badgeInput.$el.focus();
        }
      });
    }
  }
};
</script>

<style scoped>
.mission-edit-chip {
  display: flex;
  align-items: center;
  max-width: 100%;
  padding: 0.25rem 0.55rem 0.28rem;
  background: #f8f9fc;
  border: 1px solid #e6e9ef;
  border-radius: 6px;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.04);
}

.mission-edit-chip-input:disabled,
.mission-edit-chip-input[disabled] {
  flex: 1;
  min-width: 0;
  margin: 0;
  padding: 0;
  border: none;
  background: transparent !important;
  box-shadow: none !important;
  font-size: 13px;
  font-weight: 700;
  color: #2c3e50;
  opacity: 1;
  cursor: default;
  height: auto;
}

.mission-edit-chip-input:disabled::-webkit-input-placeholder {
  color: transparent;
}
</style>
